import "core-js/modules/es.array.reduce.js";

function createActionCreator(type) {
  var actionCreator = function actionCreator(payload, meta) {
    return {
      type: type,
      payload: payload,
      meta: meta
    };
  };

  actionCreator.toString = function () {
    return type;
  };

  return actionCreator;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

var reduce = function reduce(actionCreator, reducer) {
  var _a;

  return _a = {}, _a[actionCreator.toString()] = reducer, _a;
};

var createReducer = function createReducer(defaultState) {
  var reducers = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    reducers[_i - 1] = arguments[_i];
  }

  var reducersMap = reducers.reduce(function (prev, next) {
    return _assign({}, prev, next);
  }, {});
  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }

    if (reducersMap.hasOwnProperty(action.type)) {
      return reducersMap[action.type](state, action);
    }

    return state;
  };
};

var set = function set(_, action) {
  return action.payload;
};

var merge = function merge(state, action) {
  return _assign({}, state, action.payload);
};

var append = function append(state, action) {
  return state.concat(action.payload);
};

var prepend = function prepend(state, action) {
  return action.payload.concat(state);
};

var createReducerRegistry = function createReducerRegistry(initialReducersMap) {
  if (initialReducersMap === void 0) {
    initialReducersMap = {};
  }

  var currentReducerMap = _assign({}, initialReducersMap);

  var subscribers = [];
  /**
   * Subscribe to registry changes after reducers have been added or removed
   */

  var subscribe = function subscribe(subscriber) {
    subscribers.push(subscriber);
    return function () {
      subscribers = subscribers.filter(function (x) {
        return x !== subscriber;
      });
    };
  };

  var notifySubscribers = function notifySubscribers() {
    return subscribers.forEach(function (subscriber) {
      return subscriber();
    });
  };
  /**
   * Add new reducers to the registry
   */


  var add = function add(reducersMap) {
    currentReducerMap = _assign({}, currentReducerMap, reducersMap);
    notifySubscribers();
  };
  /**
   * Remove existing reducers from the registry
   */


  var remove = function remove() {
    var keys = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      keys[_i] = arguments[_i];
    }

    var newReducerMap = Object.keys(currentReducerMap).filter(function (key) {
      return !keys.includes(key);
    }).reduce(function (reducerMap, key) {
      reducerMap[key] = currentReducerMap[key];
      return reducerMap;
    }, {});
    currentReducerMap = newReducerMap;
    notifySubscribers();
  };
  /**
   * Get current reducers
   */


  var getReducersMap = function getReducersMap() {
    return currentReducerMap;
  };

  return {
    add: add,
    getReducersMap: getReducersMap,
    remove: remove,
    subscribe: subscribe
  };
};

var createSagaRegistry = function createSagaRegistry(_a) {
  var run = _a.run;
  var sagasMap = new Map();

  var add = function add() {
    var sagas = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      sagas[_i] = arguments[_i];
    }

    sagas.forEach(function (saga) {
      if (sagasMap.has(saga)) {
        return;
      }

      sagasMap.set(saga, run(saga));
    });
  };

  var remove = function remove() {
    var sagas = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      sagas[_i] = arguments[_i];
    }

    sagas.forEach(function (saga) {
      if (!sagasMap.has(saga)) {
        return;
      }

      var task = sagasMap.get(saga);
      task.cancel();
      sagasMap.delete(saga);
    });
  };

  return {
    add: add,
    remove: remove
  };
};
/* istanbul ignore next */


export { createActionCreator, reduce, createReducer, set, merge, append, prepend, createReducerRegistry, createSagaRegistry };